module.exports = __webpack_public_path__ + "static/media/2040313000.bbf1212f.jpg";